import { render, staticRenderFns } from "./table_list.vue?vue&type=template&id=4272f588&"
import script from "./table_list.vue?vue&type=script&lang=js&"
export * from "./table_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4272f588')) {
      api.createRecord('4272f588', component.options)
    } else {
      api.reload('4272f588', component.options)
    }
    module.hot.accept("./table_list.vue?vue&type=template&id=4272f588&", function () {
      api.rerender('4272f588', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/restaurants/item/tabs/tables/table_list.vue"
export default component.exports